import apiCarga from "@/services/vex/apiCarga";

async function enterpriseConfig(token) {
    try {
        const uri = `/empresa/${token}/configuracoes`;
        const result = await apiCarga.get(uri);

        let OK = result.data.status == "OK";

        if (OK) {
            const objEntrepriseConfig = {};
            result.data.data.forEach((config) => {
                objEntrepriseConfig[config.descricao.toLowerCase()] = config;
            });
            return objEntrepriseConfig;
        } else {
            throw new Error(result.data?.message);
        }

    } catch (error) {
        console.error(error);
        throw error.message;
    }
}

export default enterpriseConfig;
